import { keysToSnakeCase } from '@hotjar/webapp/lib/convert-string';
import { segment } from '@hotjar/tracking';

interface EmailsSavedProps {
  accountId: number;
  emailCount: number;
  userId: number;
}

type InvoicesEventNames = 'Billing Notification Emails Saved';

type PropertiesByInvoiceEventNamesMapType = {
  'Billing Notification Emails Saved': EmailsSavedProps;
};

export const trackInvoices = <T extends InvoicesEventNames>(
  eventName: T,
  properties: PropertiesByInvoiceEventNamesMapType[T],
): void => {
  segment.track(eventName, keysToSnakeCase(properties, true));
};
